import type { BreakfastPage } from "./types";
import React from "react";

import CommonHero from "components/commonHero/commonHero";
import TextInto from "./components/textIntro/textInto";
import UpcomingEvent from "./components/upcomingEvent/upcomingEvent";
import PreviousList from "./components/previousList/previousList";

import useBreakfastsRsvp from "./hooks";

type BreakfastViewProps = {
  pageData: BreakfastPage;
};

const BreakfastView = ({ pageData }: BreakfastViewProps) => {
  const { isReady: isRsvpReady, hasRsvped } = useBreakfastsRsvp();
  return (
    <main data-page-type="breakfast" className={"flex flex-col bg-[#F4F4F6]"}>
      <section>
        <CommonHero
          title={
            <span>
              <span className="text-cerise" aria-hidden={true}>
                ~/{" "}
              </span>
              {pageData.heading}
            </span>
          }
          subtitle={pageData.subheading}
          brandColor={"cerise"}
        />
      </section>
      <section
        className={"mb-[100px] w-full px-5 md:mx-auto md:max-w-[1040px]"}
      >
        <div data-testid={"upcoming-breakfasts"}>
          {pageData.upcoming.length > 0 && (
            <div className={"mb-[70px] mt-[30px] md:my-[60px]"}>
              <h2 className={"font-bold text-[18px] leading-[130%]"}>
                {pageData.upcomingEventsHeading}
              </h2>
              <div className={"mt-[10px]"}>
                <ul
                  className={"flex flex-col gap-[20px]"}
                  aria-label={"Upcoming events list"}
                >
                  {pageData.upcoming.map((event) => {
                    return (
                      <li
                        key={event.id}
                        aria-label={"Upcoming event"}
                        data-application-status={event.applicationsStatus}
                      >
                        <UpcomingEvent
                          event={event}
                          hasRsvped={hasRsvped}
                          isRsvpReady={isRsvpReady}
                        />
                      </li>
                    );
                  })}
                </ul>
              </div>
            </div>
          )}
        </div>
        <div className={"my-[70px] md:mt-[90px] lg:mb-[80px]"}>
          <TextInto
            heading={pageData.textHeading}
            bulletPoints={pageData.bulletPoints}
          />
        </div>
        {pageData.previous.length > 0 && (
          <div className={""}>
            <h2 className={"mb-5 font-bold text-[18px] leading-[130%]"}>
              Past events
            </h2>

            <PreviousList previous={pageData.previous} />
          </div>
        )}
      </section>
    </main>
  );
};

export default BreakfastView;
